import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import EditCrm from './EditCrm';

const CRMDetails = ({ appChoices }) => {
  const { id } = useParams();

  return (
    <Container fluid className="py-2 px-md-4">
      <div className="d-flex justify-content-end mb-2">
        <Button as={Link} to={`/crm/calendar?contact=${encodeURIComponent(id)}`} variant="outline-primary">Book Appointment</Button>
      </div>
      <Card>
        <Card.Body>
          <EditCrm id={id} appChoices={appChoices} />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CRMDetails;
